import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: true,
  isOpenFull: false,
  step: 1,
};

const menuClickSlice = createSlice({
  name: 'menuClick',
  initialState,
  reducers: {
    toggleMenu: (state) => {
      // Step progression: 1 -> 2 -> 3 -> 4 -> 1 (cycle)
      switch (state.step) {
        case 1:
          state.isOpen = false;
          state.step = 2;
          break;
        case 2:
          state.isOpen = true;
          state.step = 3;
          break;
        case 3:
          state.isOpenFull = true;
          state.step = 4;
          break;
        default:
          state.isOpenFull = false;
          state.step = 1;
          break;
      }
    },
    toggleFull: (state) => {
      state.isOpenFull = !state.isOpenFull;
      state.step = state.isOpenFull ? 4 : 3; // Sync step with isOpenFull state
    },
  },
});

export const { toggleMenu, toggleFull } = menuClickSlice.actions;
export default menuClickSlice.reducer;
